/* eslint "no-param-reassign": "off" */
import PropTypes from 'prop-types';

import React from 'react';
import { Link } from 'react-router';
import { urls } from 'helpers/url';
import { FontIcon } from 'react-toolbox';
import cx from 'classnames';
import { DragSource, DropTarget } from 'react-dnd';
import S from './savedFilters.scss';

class SavedFilterItem extends React.Component {
  render() {
    const { item, selected, onFilterSelect, isDragging,
            connectDropTarget, connectDragPreview, connectDragSource } = this.props;
    return connectDragPreview(connectDropTarget(
      connectDragSource(<li
        ref={(li) => { this.element = li; }}
        className={cx(S.filter, { [S.selected]: selected,
          [S.beingDragged]: isDragging,
          [S.overdue]: item.overdue })}
      >
        <span className={S.dragHandle}><FontIcon value="drag_handle" /></span>
        <Link
          to={urls.phases({ query: item.filters })}
          onClick={onFilterSelect}
        >
          <span className={S.name}>{item.name}</span>
          <span className={S.count}>{item.overdue_count}/{item.count}</span>
        </Link>
      </li>),
    ));
  }
}

SavedFilterItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    filters: PropTypes.object,
    count: PropTypes.number.isRequired,
    overdue_count: PropTypes.number,
    overdue: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  onFilterSelect: PropTypes.func.isRequired,
  beginDrag: PropTypes.func.isRequired,
  endDrag: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
};

const cardTarget = {

  hover: (props, monitor, component) => {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = component.getDecoratedComponentInstance().element
      .getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.move(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },

  drop: ({ index, item, endDrag }) => {
    endDrag(item, index);
  },
};

const dragSource = {
  beginDrag: ({ item, index, beginDrag }) => {
    beginDrag(item);
    return { index, item };
  },
};

/**
 * Specifies the props to inject into your component.
 */
function connectDrag(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

const connectDrop = connect => ({
  connectDropTarget: connect.dropTarget(),
});

export default DropTarget('SavedFilter', cardTarget, connectDrop)(
  DragSource('SavedFilter', dragSource, connectDrag)(SavedFilterItem),
);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/savedFilterItem.jsx